var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('v-row',{staticClass:"mx-10 fill-height pa-0"},[_c('v-col',{staticClass:"fill-height pa-0",attrs:{"cols":"12","lg":"3"}},[_c('MainNavbar')],1),_c('v-col',{attrs:{"cols":"12","lg":"9"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }